import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import ImagesApi from '../services/ImagesApiService';
import State from '../State';
import Events from '../Events';

const ClearButton = () => {
	const [loading, setLoading] = useState(false);
	const [disabled, setDisabled] = useState(State.files.length <= 0 || State.isUploading());
	function onUploading() {
		setDisabled(true);
	}
	function onUploadingDone() {
		setDisabled(false);
	}
	async function onClear() {
		setLoading(true);
		const urls = State.files.map(file => {
			return file.url;
		});
		try {
			await ImagesApi.delete(urls);
			State.clearFiles();
		} catch (error) {
			// todo
		}
		setDisabled(true);
		setLoading(false);
	}
	useEffect(() => {
		Events.OnUploading(onUploading);
		Events.OnUploadingDone(onUploadingDone);
		return () => {
			Events.OnUploading(onUploading, true);
			Events.OnUploadingDone(onUploadingDone, true);
		};
	});
	return (
		<Button
			className="clear-btn"
			onClick={onClear}
			disabled={disabled}
			loading={loading}
			type="dashed"
		>
			<DeleteOutlined />
				Delete all files
		</Button>
	);
};

export default ClearButton;



// WEBPACK FOOTER //
// ./src/components/ClearButton.js